import { Building2, Cake, MessageSquareText } from "lucide-react";

export const COLORS = {
  blue: "#0033A0",
  green: "#00843D",
  gold: "#FFB81C",
  cream: "#FDFCF0",
  ink: "#1A1A1A",
};

export const LOGO =
  "https://customer-assets.emergentagent.com/job_aum-verticals/artifacts/jsd892x0_Logo.png";

export const COMPANY = {
  name: "Aumonline",
  displayName: "AUMONLINE",
  email: "ashwath@aumonline.in",
  phoneDisplay: "+91 82175 89700",
  phoneRaw: "918217589700",
  addressLine1: "No. 401, Vaishnavi Sarovor Apartment, Plot No 4-E, 5",
  addressLine2: "Opp Gujarat Samaj Bhavan, Yadavgiri, Mysuru, Karnataka – 570020",
  city: "Mysuru",
  arn: "ARN-256095",
  euin: "E477816",
  nismValidTill: "19 October 2028",
  aum: "₹2.56 Cr",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Mutual Funds", to: "/mutual-funds" },
  { label: "Contact", to: "/contact" },
];

export const LEGAL_NAV = [
  { label: "Terms of Service", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Refund & Cancellation", to: "/refund" },
];

export const PRODUCTS = [
  {
    key: "kreta",
    name: "Kreta",
    icon: Building2,
    tag: "Co-working & field service",
    short:
      "Run an entire co-working space from one dashboard — hubs, seats, corporate clients and meeting-room bookings.",
    long:
      "Kreta manages a co-working business end to end: daily passes, meeting-room bookings, corporate seat contracts, a live occupancy dashboard, an asset and service desk, and multi-hub control. Its companion edition, Kreta-Light, handles field service and AMC — service tickets, technicians and equipment.",
    features: [
      "Co-working operations: daily passes, bookings, walk-ins",
      "Corporate seat contracts and usage tracking",
      "Live seat and occupancy dashboard",
      "Asset & service desk (Kreta-Light: field service & AMC)",
      "Mobile self-service and multi-hub control",
    ],
    url: "https://kreta.aumonline.in/",
    img: "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    key: "apoopika",
    name: "Apoopika",
    icon: Cake,
    tag: "Bakery management",
    short:
      "Complete bakery management for Indian bakeries — from recipes to dispatch.",
    long:
      "Apoopika is built specifically for Indian bakeries. It handles recipe and cost management, retail and B2B orders, kitchen and production workflows, inventory and suppliers, and packing and dispatch with delivery confirmation — all from one place.",
    features: [
      "Recipe management with cost calculation and scaling",
      "Walk-in, B2B and standing orders with GST",
      "Kitchen production workflow and quality checks",
      "Inventory, suppliers and purchase orders",
      "Packing, dispatch and delivery confirmation",
    ],
    url: "https://apoopika.aumonline.in/",
    img: "https://images.unsplash.com/photo-1711672284661-bd70e38f31b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    key: "jigyasa",
    name: "Jigyasa",
    icon: MessageSquareText,
    tag: "Enquiry & lead tracker",
    short:
      "Never lose another enquiry — capture every lead in seconds and follow up on time.",
    long:
      "Jigyasa captures every walk-in, call and website lead in ten seconds and makes sure none is forgotten. A daily call-back list, a pipeline view, ready-made WhatsApp follow-ups and an owner's business view keep the whole team on top of enquiries — on the phone or the desk.",
    features: [
      "10-second enquiry capture from any source",
      "Daily 'call back today' list with overdue flags",
      "Pipeline board, stage by stage",
      "One-tap WhatsApp follow-ups",
      "Owner's business view and why-we-lose insights",
    ],
    url: "https://jigyasa.aumonline.in/",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
];

export const MF_SERVICES = [
  {
    title: "Children's Education",
    desc: "Goal-based planning with debt-fund allocation so school and college costs are met on time.",
    link: "https://planner.aumonline.in/education-planner",
  },
  {
    title: "Retirement Planning",
    desc: "SIPs with the right equity mix to build a corpus that lasts through retirement.",
    link: "https://planner.aumonline.in/retirement-planner",
  },
  {
    title: "Wealth Preservation Post Retirement",
    desc: "A systematic withdrawal plan that turns your retirement corpus into a steady monthly income, while the rest stays invested.",
    link: "https://planner.aumonline.in/swp-planner",
  },
  {
    title: "NRI Investment Planning",
    desc: "Structured mutual-fund investing for non-resident clients, handled end to end.",
    link: "/contact",
  },
];

export const MF_PROCESS = [
  { step: "1", title: "Online / offline presentation", desc: "We understand your goals and explain the options plainly." },
  { step: "2", title: "Free account opening", desc: "Your investment account is opened at no cost." },
  { step: "3", title: "Map goals with portfolio", desc: "Investments are matched to each of your goals." },
  { step: "4", title: "Launch product basket", desc: "Your plan goes live and is reviewed over time." },
];

export const MF_LINKS = {
  openAccount:
    "https://www.njindiaonline.com/etada/partintiate.fin?cmdAction=showMenu&njBrcode=23966",
};
